import axios from "axios"

import * as actions from "../actions/auditLog"

export function getAuditLogTypeNames() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/audit-log/type-names`)
      .then((response) => {
        let typeNames = response && response.data ? response.data.$values : []
        dispatch(actions.getAuditLogTypeNames(typeNames))
      })
  }
}

export function getAuditLogEntries() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/audit-log`)
      .then((response) => {
        let auditLogEntries = response && response.data ? response.data.$values : []
        dispatch(actions.getAuditLogEntries(auditLogEntries))
      })
  }
}

export function logUserAction() {
  return (dispatch) => {
    return axios.post(`${process.env.REACT_APP_API_HOST}/api/audit-log/user-action`)
      .then((response) => {
      })
  }
}


// WEBPACK FOOTER //
// ./src/actionCreators/auditLog.js